import React from "react";
import ImageCompressor from "./ImageCompressor";
import BatchCompressor from "./BatchCompressor";
import ImageResizer from "./ImageResizer";
import CropImage from "./CropImage";
import RotateImage from "./RotateImage";
import FlipImage from "./FlipImage";
import FormatConverter from "./FormatConverter";
import { BrightnessTool, ContrastTool, BlurTool, GrayscaleTool } from "./AdjustTools";
import Base64Encoder from "./Base64Encoder";
import Base64Decoder from "./Base64Decoder";
import ColorPicker from "./ColorPicker";
import ImageToPDF from "./ImageToPDF";
import WatermarkImage from "./WatermarkImage";
import ComingSoon from "./ComingSoon";

const MAP = {
  ImageCompressor, BatchCompressor, ImageResizer, CropImage, RotateImage, FlipImage,
  FormatConverter, BrightnessTool, ContrastTool, BlurTool, GrayscaleTool,
  Base64Encoder, Base64Decoder, ColorPicker, ImageToPDF, WatermarkImage, ComingSoon,
};

export default function ToolRunner({ tool }) {
  const Comp = MAP[tool.component] || ComingSoon;
  return <Comp {...(tool.opts || {})} toolName={tool.name} />;
}
